(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');
    // service for handling agenda-week data
    module.factory('AgendaWeek', ['$rootScope', AgendaWeekFn]);

    function AgendaWeekFn($rootScope) {

        var AgendaWeek = function () {

            // day specific data
            var data = {
                sharedAgenda: {}, // the agenda to show 
                date: null, // current selected date
                weekNumber: null, // current selected week 
                appointmentsCount: 0,
                hightlightedAppointmentsCount: 0,
                week: [] // the days of the current week   
            };


            // clear
            function clear() {
                data.week = [];
                data.appointmentsCount = 0;
                data.hightlightedAppointmentsCount = 0;
            }

            // init service
            function init(weekdays) {
                // clear
                clear();

                var i = 0;
                var len = null;

                // set agenda id and date for saving
                for (var key in weekdays) {
                    var values = weekdays[key];
                    len = values.length;

                    var items = [];

                    for (i = 0; i < len; i++) {

                        // Ringfoon Operators see INTERN-Caption
                        if ($rootScope.isRingfoon) {
                            values[i].agendaLabelCaption = values[i].agendaLabelCaptionIntern || values[i].agendaLabelCaption;
                        } // if 

                        // Set Dropdown-Class (if item is at the bottom near -> dropdown goes up)
                        values[i].dropdownClass = "dropdown";
                        if (i > lineOfBreak) {
                            values[i].dropdownClass = 'dropup';
                        } // if

                        // counting ...
                        if (values[i].isAppointment) {
                            data.appointmentsCount++;
                            // is new -> unknown patient ?
                            if (values[i].highlight) {
                                data.hightlightedAppointmentsCount++;
                            } //if
                        } // if 

                        items.push(values[i]);

                    } // for

                    // length before we set dropdown up !
                    var lineOfBreak = values.length > 8 ? (values.length - 8) : values.length;
                    weekdays[key] = items;

                }

                // set weekdays
                data.week = weekdays;
            }



            // public
            this.init = init;
            this.data = data;
            this.clear = clear;
            this.collapse = collapse;

        };

        // collapse
        function collapse(collapsed) {
            // nothing to collapse
        } // collapse

        return AgendaWeek;
    }
})();